import React from 'react'
import Layout from '../../Components/Layout/Layout';

const Inicio = () => {
  return (
    <Layout>
      Inicio
    </Layout>
  )
}

export default Inicio
